var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"services-container"}},[(_vm.isDetailSelected == false)?_c('div',[_c('PSServicesOverview',{attrs:{"services":_vm.services}})],1):_vm._e(),(_vm.isDetailSelected == true)?_c('div',[_c('PSServiceDetail',{attrs:{"services":_vm.services,"detail":_vm.currentServiceDetail}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }